import create from 'zustand';
import { FormattedAlgoliaProductType } from '~/features/productsList/types';
import { Product } from '~/lib/data-contract';

export type ImpressionProduct = FormattedAlgoliaProductType | Product;
export type ImpressionProductList = ImpressionProduct[];

let timeoutId: ReturnType<typeof setTimeout>;

type UseImpressions = {
    impressions: ImpressionProductList;
    add: (
        product: ImpressionProduct,
        callback: (impressions: ImpressionProductList) => void
    ) => void;
    reset: () => void;
};

export const useImpressionsState = create<UseImpressions>((set, get) => ({
    impressions: [],
    add: (impression: ImpressionProduct, callback): void => {
        clearTimeout(timeoutId);
        set((state) => ({ impressions: [...state.impressions, impression] }));
        timeoutId = setTimeout(() => {
            const { impressions, reset } = get();
            callback(impressions);
            reset();
        }, 1000);
    },
    reset: (): void => set({ impressions: [] }),
}));
